import config from "../config";
import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", "Sorry, you have now used up all your attempts and unfortunately, you cannot proceed in the study.", "PostExposureSurveyFail", "$reason$ - $reason_details$", "app.error.postexposure")